module.exports = {"id":"221363","name":"Donny van de Beek","rating":"76","photo":"./data/images/photos/0/221363.png","club":{"name":"Ajax","logo":"./data/images/clubs/Ajax.png"},"positions":["MC","MDC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DonnyvandeBeek0.json
// module id = 1139
// module chunks = 0